// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from '@coa/app/shared/dropdown/dropdown.module';
import { SelectDateRangeFilterComponent } from '@coa/app/shared/filters/select-date-range/components/select-date-range-filter/select-date-range-filter.component';

@NgModule({
  declarations: [
    SelectDateRangeFilterComponent,
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    TranslateModule.forChild(),
    ReactiveFormsModule,
    DropdownModule,
    FormsModule,
  ],
  exports: [
    SelectDateRangeFilterComponent,
  ],
})
export class SelectDateRangeModule {
}
